import React from 'react';
import { FiArrowRight } from 'react-icons/fi';

const ConversionFlow = ({ steps, darkMode }) => {
  return (
    <div className="relative py-6 px-4">
      {/* Softer background gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-50/40 via-purple-50/30 to-blue-50/40 
                      dark:from-blue-900/20 dark:via-purple-900/15 dark:to-blue-900/20 
                      rounded-xl blur-xl">
      </div>

      {/* Subtle decorative elements */}
      <div className="absolute inset-0 bg-white/30 dark:bg-gray-900/30 rounded-xl backdrop-blur-[2px]">
        <div className="absolute inset-0 bg-gradient-to-t from-transparent via-blue-500/[0.02] to-transparent"></div>
      </div>

      {/* Centered container with improved spacing */}
      <div className="relative max-w-[95%] mx-auto">
        <div className="relative flex items-center justify-center gap-4 
                        overflow-x-auto overflow-y-hidden
                        scrollbar-thin scrollbar-track-transparent 
                        scrollbar-thumb-gray-200/60 dark:scrollbar-thumb-gray-700/60">
          {steps.map((step, index) => (
            <React.Fragment key={index}>
              <div className="flex-shrink-0 group">
                <div className="relative">
                  {/* More subtle hover effect */}
                  <div className="absolute -inset-2 bg-gradient-to-r from-blue-500/5 to-purple-500/5 
                                 rounded-lg blur-md opacity-0 group-hover:opacity-100 
                                 transition-all duration-500">
                  </div>
                  
                  {/* Step content with softer styling */}
                  <div className={`relative px-5 py-2.5 rounded-lg font-medium text-[14px]
                                  shadow-sm backdrop-blur-sm
                                  border transition-all duration-300
                                  ${darkMode 
                                    ? 'bg-gray-800/80 border-gray-700/40 text-gray-200 hover:bg-gray-800/90 hover:border-gray-600/50' 
                                    : 'bg-white/80 border-gray-200/60 text-gray-700 hover:bg-white/90 hover:border-gray-300/70'}`}>
                    {step}
                  </div>
                </div>
              </div>

              {/* Softer arrows */}
              {index < steps.length - 1 && (
                <div className="flex-shrink-0 group/arrow">
                  <FiArrowRight className={`w-4 h-4 transform transition-all duration-300
                    group-hover/arrow:translate-x-0.5
                    ${darkMode 
                      ? 'text-gray-500/80 group-hover/arrow:text-gray-400/90' 
                      : 'text-gray-400/80 group-hover/arrow:text-gray-500/90'}`} />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ConversionFlow;